import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

// Pages a read-only ROLE_ANALYTIC user is allowed to open (matched by prefix).
const ANALYTIC_ALLOWED_PATHS = ["/dashboard", "/admin/clients", "/pos", "/admin/debt/excel"];

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      // Restrict read-only ROLE_ANALYTIC users to their allowed pages, but only on
      // protected routes and only once authenticated. Running this on public routes
      // (e.g. /login) would bounce the login page and create a redirect loop.
      if (isAuthProtected && localStorage.getItem("authUser") && localStorage.getItem("role") === "ROLE_ANALYTIC") {
        const path = props.location.pathname;
        const allowed = ANALYTIC_ALLOWED_PATHS.some(p => path === p || path.startsWith(p + "/"));
        if (!allowed) {
          return <Redirect to={{ pathname: "/dashboard" }} />;
        }
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;
